module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"switchOpenContent":"Open the alert popup","switchCloseContent":"Close the alert popup","filterPushesAndPopups":"Filter pushes and popups"},"zh":{"switchOpenContent":"打开弹窗","switchCloseContent":"关闭弹窗","filterPushesAndPopups":"过滤器推送和弹出"}}')
  delete Component.options._Ctor
}
